if($('.in-index').length){

    $('.next-to-carousel-banners img').each(function(){
        $(this).wrap('<div class="wrapImage"></div>')
    })

    $.each(buttonMap, function (blockId, data) {
        var $block = $('.' + blockId);
        if (!$block.length) return;
        if ($block.find('.homepage-btn').length) return;
        $block.after('<div class="text-center customButtonsHomepage"><a href="'+data.url+'" class="btn btn-secondary">'+data.label+'</a></div>');
    });
    $(function () {
        if (!$productsBlock.length) {
            console.warn('products-24 nenalezen');
            return;
        }
        $productsBlock.find('.product').each(function () {
            var $product = $(this);
            var code = String($product.find('[data-micro="sku"]').text().trim());
            console.log(code)
            if (!code) return;
            //console.log('Načítám data pro code:', code);

            $.ajax({
            url: 'https://php.shopcode.cz/api/zahradnictvi-spomysl-Hu/api-product-by-code.php',
            method: 'GET',
            dataType: 'json',
            data: {
                code: String(code)
            },
            success: function (response) {

                if (!response.product) {
                    console.warn('Produkt nenalezen');
                    return;
                }
                $product.find('.image img').removeAttr('data-next');
                $product.find('.p-tools a.btn').text(translation('produktu'))
                $product.find('.p').append('<ul class="parameters"></ul>');
                $product.find('.p-in-in').append('<ul class="parameters"></ul><div class="superDescription">'+response.product.short_description+'</div>')
                var $params = $product.find('.parameters');
                $params.empty();
                if (response.parameters && response.parameters.length) {

                    // najdeme parametr "Vlastnosti"
                    var vlastnostiParam = response.parameters.find(function (p) {
                        return p.name && p.name.toLowerCase() === translation('vlastnosti').toLowerCase();
                    });

                    if (!vlastnostiParam || !vlastnostiParam.value) return;

                    // rozdělení podle čárky
                    var items = vlastnostiParam.value.split(',');

                    $.each(items, function (i, rawValue) {

                        var value = rawValue.trim();
                        var slug = value
                            .toLowerCase()
                            .replace(/č/g,'c').replace(/ě/g,'e').replace(/š/g,'s')
                            .replace(/ř/g,'r').replace(/ž/g,'z').replace(/ý/g,'y')
                            .replace(/á/g,'a').replace(/í/g,'i').replace(/é/g,'e')
                            .replace(/ů/g,'u').replace(/ú/g,'u').replace(/ň/g,'n')
                            .replace(/[^a-z0-9]+/g,'-')
                            .replace(/^-+|-+$/g,'');
                        // Výška / Šířka → jen hodnota
                        if (/^(výška|šířka)/i.test(value)) {
                            value = value.replace(/^(výška|šířka)\s*/i, '').trim();
                        }

                        // slug z hodnoty
                        

                        var iconUrl = '/user/documents/upload/detail/top-vlastnosti/' + slug + '.svg';

                        $params.append(
                            '<li class="property property-' + slug + '">' +
                                '<span class="property-icon"><img src="'+iconUrl+'" alt="'+rawValue.trim()+'"></span>' +
                                '<span class="property-text">' + value + '</span>' +
                            '</li>'
                        );
                    });
                }

            },
            error: function (xhr) {
                console.error('API chyba:', xhr.responseText);
            }
            });
        });
    });
}